<template lang="pug">
  transition(name="scroll-bottom")
    .email-capture-modal(v-if="modalShown")
      .email-capture-modal-wrapper.xs-12.xs-f-small.sm-f-xsmall.md-f-xsmall.max-at-tweak
        .first-line.mb-10
          .title.upper.brand-color-1.bold {{subscribed ? config.title.success : config.title.default}}
          button.btn-close.transparent-btn.xs-f-medium.sm-f-small(
            type="button"
            @click="closeModal"
            aria-label="Close email capture modal"
            data-mr-ass="close-email-capture-modal"
          )
            span.icon-x

        p.description.mb-20(v-if="subscribed" v-html="config.description.success")
        p.description(v-else v-html="config.description.default")

        transition(name="fade")
          EmailCaptureForm(
            v-if="!subscribed"
            type="modal"
            :code="config.code"
            :emailSource="config.email_source"
          )

        p.conditions.xs-f-xsmall.sm-f-xxsmall.max-at-tweak(v-if="!subscribed" v-html="config.conditions")
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import EmailCaptureForm from '../EmailCaptureForm';
  import { getModalConfig } from '../utils';
  import { EMAIL_CAPTURE_DEFAULT_CONFIG } from '../constants';

  const EMAIL_CAPTURE_HCB_EXPERIMENT = 'email capture hcb experiment';

  export default {
    name: 'EmailCaptureModal',

    components: {
      EmailCaptureForm,
    },

    data: () => ({
      experimentVariation: null,
    }),

    computed: {
      ...mapGetters('emailCapture', [
        'modalShown',
        'subscribed',
      ]),

      config() {
        // default config on control variation
        if (!this.experimentVariation || this.experimentVariation === 'A') {
          return EMAIL_CAPTURE_DEFAULT_CONFIG;
        }
        return getModalConfig();
      },
    },

    mounted() {
      const onColorBarRoutes = window.location.pathname.indexOf('/colorbar') === 0;
      this.experimentVariation = window.experiments[EMAIL_CAPTURE_HCB_EXPERIMENT];
      
      // only on /colorbar/**/* routes
      if (this.experimentVariation && onColorBarRoutes) {
        this.mix_trackExperimentViewed(EMAIL_CAPTURE_HCB_EXPERIMENT);
      }
    },

    methods: {
      ...mapActions('emailCapture', [
        'closeModal',
      ]),
    },
  };
</script>

<style lang="stylus">
  .scroll-bottom-enter-active,
  .scroll-bottom-leave-active
    transition transform .2s ease-out

  .scroll-bottom-enter,
  .scroll-bottom-leave-to
    transform(translateY(100%))

  .email-capture-modal
    position fixed
    max-width 100%
    z-index 49
    background-color ui-color-3
    border 1px solid color-fog-light
    border-top-right-radius 1em
    border-top-left-radius 1em
    max-height 80vh
    width 30em
    overflow hidden
    padding 2em 2em 1em 2em
    bottom 0
    left 1em
    box-shadow 0 -2px 12px 0 rgba(0, 0, 0, 0.12)
    .email-capture-modal-wrapper
      .first-line
        display flex
        flex-direction row
        justify-content space-between
        align-items center
        .btn-close
          padding 0
          color brand-color-2
  @media mq-mobile
    .email-capture-modal
      padding 2em 1em 1em 1em
      left 0
      width 100%
      max-width 100%
</style>
